










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import ShoppingCartWizard from '@accounting/components/shopping-cart/wizard/shopping-cart-wizard.vue';
import ShoppingCartContinueShopping from '@accounting/components/shopping-cart/shopping-cart-continue-shopping.vue';

@Component({
  name: 'bpc-shopping-cart-page',
  components: {
    'bpc-page-title': BpcPageTitle,
    'bpc-shopping-cart-wizard': ShoppingCartWizard,
    'bpc-shopping-cart-continue-shopping': ShoppingCartContinueShopping,
  },
})
export default class ShoppingCartPage extends Vue {
  step: string = 'product-list';
}
